import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-detail-compte-tab",
  templateUrl: "./detail-compte-tab.component.html",
  styleUrls: ["./detail-compte-tab.component.scss"],
})
export class DetailCompteTabComponent {
  codeClient: String;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.codeClient = params["codeClient"];
    });
  }
}
